// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__fxv4I","emails":"CreateEditClinics_emails__1x3Qd","emailTagLabel":"CreateEditClinics_emailTagLabel__2gnsa"};